import uuidv4 from 'uuid/v4';

export const queryParser = () => {
  const { hash, search } = window.location;
  const hasParams = hash
    .substring(1)
    .split('&')
    .reduce((params, pair) => {
      const [key, value] = pair.split('=');
      return value ? Object.assign({ [key]: value }, params) : params;
    }, {});

  const queryParams = search
    .substring(1)
    .split('&')
    .reduce((params, pair) => {
      const [key, value] = pair.split('=');
      return value ? Object.assign({ [key]: value }, params) : params;
    }, {});

  const bankId = hasParams.bankId || queryParams.bankId;
  const brandId = hasParams.brandId || queryParams.brandId || bankId;
  const accessToken = hasParams.access_token || queryParams.access_token || '';
  const productCode = hasParams.applyFor || queryParams.applyFor || '';
  const accountId = hasParams.accountId || queryParams.accountId || '';
  const internetBanking = hasParams.internetBanking || queryParams.internetBanking || 'false';
  const reason = hasParams.reason || queryParams.reason || '';
  const userTrackingId = hasParams.user_tracking_id || queryParams.user_tracking_id || '';
  const caseId = hasParams.caseId || queryParams.caseId || '';
  const redirectUrl =
    hasParams.redirectUrl && hasParams.redirectUrl.length > 0
      ? decodeURIComponent(hasParams.redirectUrl)
      : queryParams.redirectUrl && queryParams.redirectUrl.length > 0
      ? decodeURIComponent(queryParams.redirectUrl)
      : '';
  const uuid = hasParams.user_tracking_id || queryParams.user_tracking_id || uuidv4();

  return {
    bankId,
    brandId,
    accessToken,
    productCode,
    accountId,
    internetBanking,
    redirectUrl,
    uuid,
    reason,
    userTrackingId,
    caseId
  };
};
